<template>
    <div>
        <h1>
            {{ form.name }}
        </h1>
        <el-divider />
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" class="form-container">
            <el-form-item :label="$t('Name')" prop="name">
                <el-input v-model="form.name" :placeholder="$t('Name')" :disabled="!isEditing"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Real Name')" prop="realName">
                <el-input v-model="form.realName" :placeholder="$t('Real Name')" :disabled="!isEditing"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Phone')" prop="phone">
                <el-input v-model="form.phone" :placeholder="$t('Phone')" :disabled="!isEditing"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Email')" prop="email">
                <el-input v-model="form.email" :placeholder="$t('Email')" :disabled="!isEditing"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Password')" prop="password">
                <el-input v-model="form.password" :placeholder="$t('Password')" :disabled="!isEditing" show-password
                    type="password"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Confirm Password')" prop="confirmPassword">
                <el-input v-model="form.confirmPassword" :placeholder="$t('Confirm Password')" :disabled="!isEditing"
                    show-password type="password"></el-input>
            </el-form-item>
            <el-form-item v-if="isEditing">
                <el-button type="primary" @click="handleSubmit">{{ $route.params.id ? $t('Update') : $t('Create') }}</el-button>
                <el-button type="success" @click="isEditing = false">{{ $t('Cancel') }}</el-button>
                <!-- <el-button link type="warning" @click="toLogin">Login</el-button> -->
            </el-form-item>
            <el-form-item v-if="!isEditing">
                <el-button type="primary" @click="isEditing = true">{{ $t('Edit') }}</el-button>
                <!-- <el-button link type="warning" @click="toLogin">Login</el-button> -->
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js'


export default {
    name: 'ParentInfo',
    data() {
        return {
            isEditing: this.$route.params.id ? false : true,

            form: {
                name: '',
                realName: '',
                phone: '',
                email: '',
                password: '',
                confirmPassword: ''
            },

            rules: {
                name: [
                    { required: true, message: this.$t('Name is required'), trigger: 'blur' },
                    { min: 2, max: 20, message: this.$t('Length must be 2 to 20 characters'), trigger: 'blur' }
                ],
                realName: [
                    { required: true, message: this.$t('Real Name is required'), trigger: 'blur' },
                    { min: 2, max: 20, message: this.$t('Length must be 2 to 20 characters'), trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: this.$t('Phone is required'), trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: this.$t('Invalid phone number'), trigger: 'blur' }
                ],
                email: [
                    { required: true, message: this.$t('Email is required'), trigger: 'blur' },
                    { type: 'email', message: this.$t('Invalid email address'), trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('Password is required'), trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: this.$t('Confirm Password is required'), trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.fetchParent();
    },
    methods: {
        toLogin() {
            this.$router.push({name: 'BackendLogin'});
        },
        validateConfirmPassword(rule, value, callback) {
            console.log("rule", rule);   
            if (value !== this.form.password) {
                callback(new Error(this.$t('Passwords do not match')));
            } else {
                callback();
            }
        },
        async createParent(data) {
            try {
                const response = await axios.post(`${BACKEND_URL}/api/parent/create`, data);
                this.$message.success(this.$t('Parent created successfully!'));
                return response;
            } catch (error) {
                this.$message.error(this.$t('Failed to create parent'));
                throw error;
            }
        },
        updateParent(id, data) {
            axios.put(`${BACKEND_URL}/api/parent/update/${id}`, data).then(response => {
                this.$message.success(this.$t('Parent updated successfully!'));
                this.$router.push({name: 'ParentInfo', params: {id: response.data.id}});
            });
        },
        fetchParent() {
            const id = this.$route.params.id;
            if (id) {
                axios.get(`${BACKEND_URL}/api/parent/${id}`).then(response => {
                    this.form = response.data;
                });
            } else {
                this.form = {
                    name: '',
                    phone: '',
                    email: '',
                    password: '',
                    confirmPassword: ''
                };
            }
        },
        async handleSubmit() {
            try {
                const valid = await this.$refs.formRef.validate();
                if (!valid) {
                    return;
                }

                const id = this.$route.params.id;
                const data = {
                    name: this.form.name,
                    realName: this.form.realName,
                    phone: this.form.phone,
                    email: this.form.email,
                    avatar: this.form.avatar,
                    password: this.form.password,
                    confirmPassword: this.form.confirmPassword,
                };
        
                if (id) {
                    this.updateParent(id, data);
                    this.isEditing = false;
                    this.$message.success(this.$t('Parent info updated successfully!'));
                } else {
                    const response = await this.createParent(data);
                    console.log("response", response);
                    this.$confirm(this.$t('Are you sure you want to proceed to the login page?'), this.$t('Confirmation'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({ name: 'BackendLogin' });
                    }).catch(() => {
                        this.$message.info(this.$t('Action cancelled'));
                    });
                    // this.$router.push({ name: 'ParentInfo', params: { id: response.data.id } });
                }
            } catch (error) {
                console.error(this.$t('Form submission error:'), error);
                this.$message.error(this.$t('Failed to submit form'));
            }
        }
    }
}
</script>

<style scoped>
.parent-info {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
}

.avatar-uploader {
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
}

.form-container {
    margin: 0 auto;
    padding: 20px;
}

h1 {
    font-size: 24px;
    padding-left: 20px;
}

</style>
